<template>
    <div :class="feedStyle" :id="item.posId">
        <v-menu style="float: right" v-if="$store.state.auth.user.role==4">
            <div slot="activator" class="editPost">
                <v-icon small>more_horiz</v-icon>
            </div>
            <v-list>
                <v-list-tile
                        href="#"
                        @click="editPost"
                        key="edit"
                        v-if="item.creator == user.userId && editable"
                >
                    <v-list-tile-action>
                        <v-icon>edit</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{$t('lang.common.edit')}}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                        @click="deletePost"
                        key="delete"
                        v-if="item.creator == user.userId && editable"
                >
                    <v-list-tile-action>
                        <v-icon>delete</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{$t('lang.common.delete')}}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <!--v-list-tile
                        @click="copyLinkPost"
                        key="copy"
                >
                    <v-list-tile-action>
                        <v-icon>content_copy</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{$t('lang.feed.copyLink')}}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="!saved"
                             @click="saveLink"
                             key="saveLink"
                >
                    <v-list-tile-action>
                        <v-icon>save</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{$t('lang.common.saveLink')}}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-if="saved"
                             @click="unSaveLink"
                             key="unSaveLink"
                >
                    <v-list-tile-action>
                        <v-icon>delete</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{$t('lang.common.unSaveLink')}}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile -->
                <v-list-tile @click="toTop" v-if="item.onTop==0"
                             key="on_top"
                >
                    <v-list-tile-action>
                        <v-icon>vertical_align_top</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Ghim bài viết lên đầu
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="onRemoveTop"
                             key="on_remove_top"
                             v-if="item.onTop==1"
                >
                    <v-list-tile-action>
                        <v-icon>remove</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Bỏ ghim bài viết
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="enableComment" v-if="item.enableComment==0"
                             key="on_comment"
                >
                    <v-list-tile-action>
                        <v-icon>comment</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Bật tính năng bình luận
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="disableComment"
                             key="on_enable_comment"
                             v-if="item.enableComment==1"
                >
                    <v-list-tile-action>
                        <v-icon>block</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Tắt tính năng bình luận
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>
        <div style="display: flex">
            <!--img :src="item.avatar" class="smallAvatar"/-->
            <i-avatar :user-id="item.creator" size="smallAvatar"/>
            <div class="postInfo" style="flex-grow: 1">
                <div class="postCreator">
                    {{item.creatorName}}
                </div>
                <div class="postTime">{{item.createdAt | formatDateTime}}</div>
            </div>
            <div style="margin-right: 10px;font-style: italic;color:blue;cursor: pointer" @click="showMember"><v-icon color="blue">play_arrow</v-icon>
                <label v-if="item.receivers=='0'">Cả lớp</label>
                <label v-else-if="$store.state.auth.user.role==2 && getNumberOfReceiver(item)==1">{{'Bạn'}}</label>
                <label v-else-if="$store.state.auth.user.role==2 && getNumberOfReceiver(item)>1">{{'Bạn & '+ (getNumberOfReceiver(item)-1)+' học viên khác'}}</label>
                <label v-else>{{getNumberOfReceiver(item)+' học viên'}}</label>
            </div>
        </div>
        <div class="postTitle link" v-if="item.url != undefined && item.url != null" @click="showURL(item.url)">
            {{item.title}}
        </div>

        <a href="#" class="postTitle" v-else-if="item.objectType == 5 || item.objectType == 6" @click="onview(item)">
            Giáo viên {{item.creatorName}} đã giao bài tập: {{item.title}}</a>
        <div class="postTitle" v-else>{{item.title}}</div>
        <!--div v-if="item.objectType == 5 || item.objectType == 6">Ngày đến hạn: {{item.dueDate | formatDateTime}}</div-->
        <div v-if="item.objectType == 5 || item.objectType == 6">
            <div>
                {{$t('lang.exercise.dueDate')}}:{{item.dueDate | formatDate}}&nbsp
                <span v-html="getRemainTime(item.dueDate)"></span>
            </div>
            <div>Hình thức: {{getExerciseType(item.objectType)}}</div>
            <div>Thời gian: {{item.questionTime}} phút</div>
            <div v-if="$store.state.auth.user.role==4">
                Đã nộp:
                {{item.numberOfComplete}}/{{getNumberOfReceiver(item)}}
            </div>
            <div v-if="$store.state.auth.user.role==4">
                Đã chấm:
                {{item.numberOfMarked!=null?item.numberOfMarked:0}}/{{getNumberOfReceiver(item)}}
            </div>
        </div>
        <div v-else>
            <div class="postContent">{{item.content}}</div>
            <div class="postTags">{{item.tags}}</div>
        </div>
        <div>
            <div v-for="md in media" class="mediaPost">
                <img :src="md.url" :class="getClassOfImage(md)" v-if="md.type.indexOf('image/')>=0"/>
                <video controls v-else-if="md.type.indexOf('video/')>=0">
                    <source :src="md.url" :type="md.type">
                    Your browser does not support the video tag.
                </video>
                <div v-else class="documentFile">
                    <a :href="md.url">{{md.fileName}}</a>
                </div>
                <div class="mediaTitle" v-if="md.title != undefined && md.title != null && md.title !='' ">
                    <a :href="item.url">{{md.title}}</a>
                </div>
            </div>
        </div>
        <!--div class="postAction" v-if="item.objectType == 5 || item.objectType == 6"
             style="display: flex;line-height: 35px">
        </div-->
        <div class="postAction" style="display: flex;padding: 10px;line-height: 35px"
             v-if="(item.numberOfLike != null && item.numberOfLike>0) || (item.numberOfComment != null && item.numberOfComment>0)">
            <div style="display: flex; flex-grow: 1;color:blue">
                <v-btn fab color="blue" style="width:25px;height: 25px">
                    <v-icon style="color:white" small>thumb_up</v-icon>
                </v-btn>
                &nbsp; {{item.numberOfLike}}
            </div>
            <div style="display: flex;cursor: pointer" @click="oncomment(item)">
                {{item.numberOfComment}}
                {{$t('lang.feed.comment')}}
            </div>
        </div>
        <div class="postAction" v-if="editable">
            <v-btn flat @click="onlike(item)" :color="likeColor" v-if="item.objectType != 8">
                <v-icon small>thumb_up</v-icon> &nbsp;&nbsp; {{$t('lang.feed.like')}}
            </v-btn>
            <v-btn flat @click="oncomment(item)" v-if="item.enableComment==1 &&  item.objectType != 8">
                <v-icon small>comment</v-icon>&nbsp;&nbsp; {{$t('lang.feed.comment')}}
            </v-btn>
            <v-btn flat @click="onview(item)"
                   v-if="(item.objectType == 5 || item.objectType == 6) && $store.state.auth.user.role==4 && (item.numberOfMarked == null || item.numberOfMarked < getNumberOfReceiver(item))">
                <v-icon small>visibility</v-icon>&nbsp;&nbsp; Chấm bài
            </v-btn>
            <v-btn flat @click="onViewExerciseReport(item)"
                   v-if="(item.objectType == 5 || item.objectType == 6) && $store.state.auth.user.role==4 && item.numberOfMarked == getNumberOfReceiver(item)">
                <v-icon small>bar_chart</v-icon>&nbsp;&nbsp; Gửi báo cáo
            </v-btn>
            <v-btn flat @click="onViewReport(item)"
                   v-if="item.objectType == 8">
                <v-icon small>bar_chart</v-icon>&nbsp;&nbsp; Xem báo cáo
            </v-btn>
            <v-btn flat @click="onview(item)"
                   v-if="(item.objectType == 5 || item.objectType == 6) && $store.state.auth.user.role==2">
                <v-icon small>visibility</v-icon>&nbsp;&nbsp; Xem bài tập
            </v-btn>
        </div>
        <div class="postComment" v-if="item.enableComment==1 && item.objectType != 8">
            <div class="comment" v-for="cm in lstComment" :key="cm.postId">
                <i-avatar :user-id="cm.creator"/>
                <div style="flex-grow: 1" @click="showURL(cm.url)">
                    <div class="commentDetail">
                        <label class="postCreator">
                            {{cm.creatorName}}:
                        </label>
                        {{cm.content}}
                    </div>
                    <div v-for="md in cm.media" :key="md.attachId" class="mediaComment">
                        <img :src="md.url" :class="getClassOfImage(md)" v-if="md.type.indexOf('image/')>=0"/>
                        <video controls v-else-if="md.type.indexOf('video/')>=0">
                            <source :src="md.url" :type="md.type">
                            Your browser does not support the video tag.
                        </video>
                        <div v-else class="documentFile">
                            <a :href="md.url">{{md.fileName}}</a>
                        </div>
                        <div class="mediaTitle" v-if="md.title != undefined && md.title != null && md.title !='' ">
                            {{md.title}}
                        </div>
                    </div>
                    <div class="postTimeComment">{{cm.createdAt | fromNow}}</div>
                </div>
                <v-menu style="float: right" v-if="cm.creator == user.userId&&editable">
                    <div slot="activator" class="editPost">
                        <v-icon small style="margin-right: 5px;line-height: 40px">more_horiz</v-icon>
                    </div>
                    <v-list>
                        <v-list-tile
                                href="#"
                                @click="editComment(cm)"
                                key="edit"
                        >
                            <v-list-tile-action>
                                <v-icon>edit</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{$t('lang.common.edit')}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                                @click="deleteComment(cm)"
                                key="delete"
                        >
                            <v-list-tile-action>
                                <v-icon>delete</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{$t('lang.common.delete')}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
            <div class="comment" v-if="editable">
                <i-avatar :user-id="user.userId"/>
                <input :placeholder="$t('lang.feed.pleaseComment')" class="postCommentInput" v-model="comment"
                       @paste="onPaste" maxlength="1000"
                       @keypress.enter="postComment(item)"/>
                <v-icon @click="openFileDialog" style="margin-left: 5px">camera_alt</v-icon>
                <v-icon @click="postComment(item)" color="primary" style="margin-left: 5px">send</v-icon>
                <input type="file" :id="uploadId" style="display: none" class="file" @change="onFilePicked"
                       :accept="accept"/>
            </div>
            <div style="">
                <div v-for="item in commentImages" class="mediaPost">
                    <div class="delItem" @click="deleteAttach(item)"></div>
                    <img :src="item.url" class="imagePost" v-if="item.type.indexOf('image/')>=0"/>
                    <video controls v-else-if="item.type.indexOf('video/')>=0">
                        <source :src="item.url" :type="item.type">
                        Your browser does not support the video tag.
                    </video>
                    <div v-else class="documentFile">
                        <a :href="item.url">{{item.fileName}}</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import DateUtils from "../../../public/js/DateUtils";
    import moment from "moment";

    export default {
        components: {TeacherInfo, ClazzCreate},
        props: {
            item: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            objectType: {
                type: String | Number,
                default: 0
            },
            classId: {
                type: String | Number,
                default: null
            },
            editable: {
                type: Boolean,
                default: true
            },
            saved: {
                type: Boolean,
                default: false
            }

        },
        data() {
            return {
                showComment: false,
                comment: "",
                commentId: null,
                commentURL: null,
                commentImages: [],
                lstComment: [],
                user: {},
                content: "",
                url: "",
                onTop: 0,
                accept: "video/*,  video/x-m4v, video/webm, video/x-ms-wmv, video/x-msvideo, video/3gpp, video/flv, video/x-flv, video/mp4, video/quicktime, video/mpeg, video/ogv, .ts, .mkv, image/*, image/heic, image/heif, .docx,.doc,.xlsx,.xls,.pdf,.ppt,.pptx",
                fileContent: null,
                fileURL: null,
                fileName: null,
                fileType: null,
            }
        },
        computed: {
            likeColor: function () {
                if (this.item.liked == 0) {
                    return "";
                } else {
                    return "blue";
                }

            },

            media: function () {
                if (this.item.images != null && this.item.images != "") {
                    let rt = null;
                    try {
                        rt = JSON.parse(this.item.images);
                    } catch (e) {
                        //console.log(this.item.images);
                    }
                    return rt;
                } else {
                    return null;
                }
            },

            uploadId: function () {
                return "commentUpload" + this.item.postId;
            },

            feedStyle: function () {
                return "feed feed" + this.item.objectType;
            }

        },

        created() {
            this.user = this.$store.state.auth.user;
            ////console.log(this.user);
            ////console.log(this.item);
            /*
                        //console.log("--- comment ---");
                        //console.log(this.lstComment);
            */
        },

        methods: {
            showMember(){
               this.$emit("member",this.item.receivers);
            },

            getRemainTime(time) {
                time = time;
                let now = new Date();
                let t = new Date(time);
                t.setHours(23);
                t.setMinutes(59);
                t.setSeconds(59);
                if (t.getTime() < now.getTime()) {
                    return "<span style='color:red'>(Đã hết hạn)</span>";
                } else {
                    return "<span style='color:blue'>(" + moment(t).fromNow() + ")</span>";
                }
            },

            getNumberOfReceiver(item) {
                if (item.receivers == null || item.receivers == "") {
                    return "";
                } else {
                    if(item.receivers == '0' || item.receivers == 0){
                        return -1;
                    } else {
                        //console.log("here");
                        return item.receivers.split(",").length;
                    }
                }
            },

            getExerciseType(type) {
                if (type == 5) {
                    return "Tự luận"
                } else if (type == 6) {
                    return "Trắc nghiệm";
                }
            },

            postComment: function () {
                if (this.comment.trim().length == 0 && this.commentImages.length == 0) {
                    message.error("Bạn chưa nhập nội dung bình luận");
                    return;
                }
                let comment = {
                    classId: this.item.classId,
                    content: this.comment,
                    images: JSON.stringify(this.commentImages),
                    objectType: 4,
                    url: this.commentURL,
                    parentId: this.item.postId
                }
                axios.post(process.env.VUE_APP_API_URL + "/post/save", comment).then(
                    data => {
                        this.comment = "";
                        this.commentImages = [];
                        this.commentURL = null;
                        this.getComment();
                    },
                    error => {

                    }
                )

            },

            getComment: function () {
                let postId = this.item.postId;
                axios.post(process.env.VUE_APP_API_URL + "/post/onGetComment?postId=" + postId).then(
                    data => {
                        this.lstComment = data;
                        for (let i = 0; i < this.lstComment.length; i++) {
                            if (this.lstComment[i].images != null && this.lstComment[i].images != "") {
                                this.lstComment[i].media = JSON.parse(this.lstComment[i].images);
                            }
                        }
                        this.item.numberOfComment = this.lstComment.length;
                    },
                    error => {

                    }
                )

            },

            onlike: function () {
                let postId = this.item.postId;
                axios.post(process.env.VUE_APP_API_URL + "/post/like?postId=" + postId).then(
                    data => {
                        if (this.item.liked == 0) {
                            this.item.liked = 1;
                            this.item.numberOfLike++;
                        } else {
                            this.item.liked = 0;
                            this.item.numberOfLike--;
                        }
                    },
                    error => {

                    }
                )
            },

            oncomment: function () {
                this.showComment = !this.showComment;
                this.getComment();

            },

            onview: function () {
                this.$emit("view", this.item);
            },

            onViewExerciseReport: function () {
                this.$emit("exercise_report", this.item);
            },

            onViewReport: function () {
                this.$emit("report", this.item);
            },

            onLoad: function () {
                //console.log("onload");
                let frame = document.getElementById("frame" + this.item.postId);
                let frameDoc = frame.contentDocument || frame.contentWindow.document;
                let meta = frameDoc.getElementsByTagName("meta");
                let post = {};
                for (let i = 0; i < meta.length; i++) {
                    if ("og:title" == meta[i].getAttribute("property")) {
                        post.title = meta[i].getAttribute("content");
                    } else if ("og:description" == meta[i].getAttribute("property")) {
                        post.content = meta[i].getAttribute("content");
                    } else if ("og:image" == meta[i].getAttribute("property")) {
                        post.image = meta[i].getAttribute("content");
                    }
                }
                //console.log(post);
            },

            onPaste: function (event) {
                let data = event.clipboardData.getData('Text');
                if (data.toLowerCase().indexOf("http://") >= 0 || data.toLowerCase().indexOf("https://") >= 0) {
                    axios.post(process.env.VUE_APP_API_URL + "/post/urlParse", data).then(
                        data => {
                            this.comment = data.title;
                            if (data.images != undefined && data.images != null) {
                                this.commentImages = JSON.parse(data.images);
                            }
                            this.commentURL = data.url;
                            this.commentId = null;
                        },
                        error => {

                        }
                    );

                }
            },

            editPost: function () {
                if (this.item.creator == this.user.userId) {
                    if (this.item.objectType == 5 || this.item.objectType == 6) {
                        this.onview();
                    } else {
                        this.$emit("edit", this.item);
                    }
                } else {
                    message.error(this.$t("lang.common.permissionNotAllow"));
                }
            },

            copyLinkPost: function () {
                let postId = this.item.postId;
                let link = process.env.VUE_APP_FRONTEND_URL + "/#/post/item/" + postId;
                navigator.clipboard.writeText(link);

            },

            saveLink: function () {
                let postId = this.item.postId;
                axios.post(process.env.VUE_APP_API_URL + "/post/saveLink?postId=" + postId).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.save_success"));
                        } else {
                            message.error(data.description);
                        }
                    },
                    error => {

                    }
                )
            },

            unSaveLink: function () {
                let postId = this.item.postId;
                axios.post(process.env.VUE_APP_API_URL + "/post/unSaveLink?postId=" + postId).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.delete_success"));
                            this.$emit("reload");
                        } else {
                            message.error(this.$t("lang.common.deleteError"));
                        }
                    },
                    error => {

                    }
                )
            },

            toTop: function () {
                let postId = this.item.postId;
                axios.post(process.env.VUE_APP_API_URL + "/post/top?postId=" + postId).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.save_success"));
                            this.$emit("reload");
                        } else {
                            message.error(data.description);
                        }
                    },
                    error => {

                    }
                )
            },

            onRemoveTop: function () {
                let postId = this.item.postId;
                axios.post(process.env.VUE_APP_API_URL + "/post/untop?postId=" + postId).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.save_success"));
                            this.$emit("reload");
                        } else {
                            message.error(data.description);
                        }
                    },
                    error => {

                    }
                )
            },

            editComment: function (cm) {
                //console.log(cm);
                if (cm.creator == this.user.userId) {
                    this.$emit("editComment", cm, this);
                } else {
                    message.error(this.$t("lang.common.permissionNotAllow"));
                }
            },


            enableComment: function () {
                let postId = this.item.postId;
                axios.post(process.env.VUE_APP_API_URL + "/post/enableComment?postId=" + postId).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.save_success"));
                            this.$emit("reload");
                        } else {
                            message.error(data.description);
                        }
                    },
                    error => {

                    }
                )
            },

            disableComment: function () {
                let postId = this.item.postId;
                axios.post(process.env.VUE_APP_API_URL + "/post/disableComment?postId=" + postId).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.save_success"));
                            this.$emit("reload");
                        } else {
                            message.error(data.description);
                        }
                    },
                    error => {

                    }
                )
            },

            deleteComment: function (cm) {
                if (confirm(this.$t("lang.common.deleteConfirm"))) {
                    axios.post(process.env.VUE_APP_API_URL + "/post/delete", cm).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.delete_success"));
                                this.getComment();
                            } else {
                                message.error(this.$t("lang.common.deleteError"));
                            }
                        },
                        error => {

                        }
                    )

                }

            },

            deletePost: function () {
                if (confirm(this.$t("lang.common.deleteConfirm"))) {
                    axios.post(process.env.VUE_APP_API_URL + "/post/delete", this.item).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.delete_success"));
                                this.$emit("reload");
                            } else {
                                message.error(this.$t("lang.common.deleteError"));
                            }
                        },
                        error => {

                        }
                    )

                }
            },

            deleteAttach: function (item) {
                for (let i = 0; i < this.commentImages.length; i++) {
                    if (this.commentImages[i].url == item.url) {
                        this.commentImages.splice(i, 1);
                        break;
                    }
                }
            },

            showURL: function (url) {
                if (url == undefined || url == null || url == "") {
                    return;
                }
                window.open(url);
            },

            openFileDialog() {
                document.getElementById("commentUpload" + this.item.postId).click();
            },

            uploadFile: function () {
                let formData = new FormData();
                formData.append("uploadfile", this.fileContent);
                formData.append("sourceId", "");
                formData.append("sourceType", "1");
                formData.append("attachTitle", "");
                axios.post(process.env.VUE_APP_API_URL + "/upload/save", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(
                    data => {
                        let md = {
                            url: process.env.VUE_APP_API_URL + "/download/attach/" + data.id,
                            type: this.fileType,
                            fileName: this.fileName
                        }
                        this.commentImages.push(md);
                        ////console.log(this.commentImages);
                    },
                    error => {
                        message.error("upload failed");
                    }
                );
            },

            onFilePicked: function (e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    ////console.log(files[0]);
                    this.fileName = files[0].name;
                    this.fileType = files[0].type;
                    if (this.fileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.fileURL = fr.result;
                        this.fileContent = files[0]; // this is an file that can be sent to server...
                        this.uploadFile();
                    })
                }
            },

            getClassOfImage: function (item) {
                if (item.title != undefined && item.title != null && item.t != "") {
                    return "imageUrl";
                } else {
                    return "imagePost";
                }
            }
        }
    };
</script>